import { User, UserAction, UserActionTypes } from '@app/types/user'

const initialState: User = {
	personal: {
		name: '',
		email: '',
		imageUrl: '',
		dateOfBirth: '',
		gender: '',
		phone: '',
		firstName: '',
		lastName: '',
		address1: '',
		address2: '',
		city: '',
		ZipCode: '',
		Country: '',
		state: '',
		notes: '',
		prefix: '',
	},
	employment: {
		roles: [],
		employer: '',
		accounts: [],
		expertise: [],
		patientCapacityLoad: 0,
		roleTypes: [],
		skills: [],
		startOfService: '',
		title: '',
	},
	extra: {
		firstLogin: false,
		organizationID: '',
	},
	localization: {
		carbs: '',
		dateConfiguration: '',
		glucoseLevel: '',
		language: '',
		temperature: '',
		weightHeight: '',
	},
	myOrganization: {
		orgName: '',
		orgId: '',
		imageUrl: '',
		accounts: [],
		coachCapacityLoad: 0,
		userToEngageInactiveSLA: 0,
		userToEngageNewSLA: 0,
		business_calender: {} as any,
		general_info: {
			description: {
				details: {
					org_phone: '',
					org_type: '',
					org_status: '',
					affiliation_id: '',
					description_text: '',
					website: '',
				},
				primary_contact_person: {
					email: '',
					name: '',
					phone: '',
				},
			},
			address: {
				shipping_address: {
					address_line1: '',
					address_line2: '',
					country: '',
					state: '',
					zip_code: '',
					city: '',
				},
				mailing_address: {
					address_line1: '',
					address_line2: '',
					country: '',
					state: '',
					zip_code: '',
					city: '',
				},
			},
		},
		licenseFeatures: {},
		questionnaire: [],
		eventCategoriesV2: [],
		membershipEnrollment: {
			products: [],
		},
		educationalContent: [],
		internalClinic: false,
	},
	organizations: [],
	termsOfService: {
		approved: false,
	},
	created: '',
	modified: '',
	_id: '',
	notes: '',
}

export default (state = initialState, action: UserAction): User => {
	switch (action.type) {
		case UserActionTypes.USER_GET: {
			return action.payload
		}
		case UserActionTypes.USER_UPDATE_LOCALIZATION: {
			return {
				...state,
				localization: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
